import * as actionTypes from "../actionTypes/actionTypes";
import {
  getToolsOfferedService,
  createNewToolService,
  updateToolService,
  deleteToolService
  } from "../services/ToolsOfferedService";
  import * as _ from "lodash";
const getToolsOffered = (sales) => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_TOOLS_OFFERED
        })
        window.startLoading();
        getToolsOfferedService(sales)
        .then((response)=>{
          const data = response.data;
          const sortedToolsOffered = _.sortBy(data, ['toolId']);
            dispatch({
                type: actionTypes.GET_TOOLS_OFFERED_SUCCESS,
                payload: sortedToolsOffered
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_TOOLS_OFFERED_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}


const createNewTool = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_TOOL,
    });
    window.startLoading();
    await createNewToolService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_TOOL_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_TOOL_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      })
  };
};

const updateTool = (toolsOfferedId,requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_TOOL,
    });
    window.startLoading();
    await updateToolService(toolsOfferedId, requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_TOOL_SUCCESS,
          payload: data,
          toolsOfferedId: toolsOfferedId
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_TOOL_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteTool = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_TOOL
      })
      window.startLoading();
      await deleteToolService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_TOOL_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_TOOL_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      });
  }
}

export { getToolsOffered, createNewTool, updateTool, deleteTool };
